import { Button, Divider, IconButton } from '@material-ui/core';
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlineBlank';
import Checkbox from '@material-ui/icons/CheckBoxOutlined';
import EditIcon from '@material-ui/icons/Edit';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import React from 'react';
import styled from 'styled-components';
import Utils from '../../Utils';

import GridTemplateColumns from './GridTemplateColumns';


const SubHeader = styled.div`
padding-top:10px;
display:grid;
grid-template-columns:${GridTemplateColumns};
padding-left:10px;
padding-right:10px;
padding-bottom:10px;
align-items:center;


`;

const SubHeaderText = styled.div`
color: black;
font-family: Roboto;
font-size: 14px;
font-weight: 400;
line-height: 19px;
text-align: left;
`;



const Container = styled.div`

`;


class ProceduresArchivedListItem extends React.Component {


    render() {
        const {procedure = {}} = this.props;
        const {iwpp,name,rev,effectiveDate,url,sdn,categoryName} = procedure;
        return ( 
                <Container>
                <SubHeader>
                    <div/>
                    <SubHeaderText>{sdn}</SubHeaderText>
                    <SubHeaderText>{name}</SubHeaderText>
                    <SubHeaderText>{categoryName}</SubHeaderText>
                    <SubHeaderText>{rev}</SubHeaderText>
                    <SubHeaderText>{Utils.formatDate(effectiveDate)}</SubHeaderText>
                    <div>
                        <IconButton color='primary' onClick={() => window.open(url,'_blank')}>
                            <OpenInNewIcon/>
                        </IconButton>
                    </div>
                    </SubHeader>
                <Divider/>
                </Container>
        )
    }

            
}

export default ProceduresArchivedListItem;